// Inverse de RequireAuth : réservé aux visiteurs NON connectés.
// Si un parent déjà connecté ouvre /login ou /register, on le renvoie
// directement à son espace plutôt que de lui remontrer un formulaire.
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../lib/AuthContext'

export default function GuestOnly ({ children }) {
  const { user, loading } = useAuth()

  if (loading) return <div className="bootstrap">Chargement…</div>
  if (user) return <Navigate to="/dashboard" replace />

  return children
}
